module.exports = __webpack_public_path__ + "img/amor-face-6.e47adf5a.jpg";